module.exports = __webpack_public_path__ + "img/symbol_8.0f70e940.png";